// extracted by mini-css-extract-plugin
module.exports = {"root":"SharedByBadge_root__2yJP8","title":"SharedByBadge_title__3TxIj","name":"SharedByBadge_name__I9740","email":"SharedByBadge_email__1XYO_"};